import { Routes, Route, Navigate } from "react-router-dom";
import Notification from "../pages/clubApp/text/notification/Notification";
import ClubAppDashboard from "../pages/clubApp/dashboard/ClubAppDashboard";
import ClubServiceDashboard from "../pages/clubService/dashboard/ClubServiceDashboard";
import Sales188Dashboard from "../pages/sales188/dashboard/Sales188Dashboard";
import MktDashboard from "../pages/mkt/dashboard/MktDashboard";
import TechpressoDashboard from "../pages/techpresso/dashboard/TechpressoDashboard";
import ZippyAndMeDashboard from "../pages/zippyAndMe/dashboard/zippyAndMeDashboard";
import { Dispatch, SetStateAction } from "react";
import { ServiceTypes } from "../types/types";
import ManualNotificationDetail from "../pages/clubApp/text/notification/ManualNotificationDetail";
import FaceCall from "../pages/clubApp/content/FaceCall";
import UserManagement from "../pages/permission/UserManagement";
import ProgramSetting from "../pages/permission/ProgramSetting";
import CheckInDashboard from "../pages/checkIn/dashboard/CheckInDashboard";
import VendorReports from "../pages/mkt/content/VendorReports";
import EventBanner from "../pages/clubApp/design/EventBanner";
import GoGoLive from "../pages/clubApp/design/GoGoLive";
import TrialModeDashboard from "../pages/trialMode/dataAnalysis/dashboard/Dashboard";
import LocalEvent from "../pages/trialMode/localEvent/LocalEvent";
import CaringCTA from "../pages/trialMode/caringCTA/CaringCTA";
import JourneyCard from "../pages/trialMode/journeyCard/JourneyCard";
import TrialContent from "../pages/trialMode/trialContent/TrialContent";
import TrialContentUpload from "../pages/trialMode/trialContentUpload/TrialContentUpload";
import ImportantNotice from "../pages/clubApp/content/ImportantNotice";
import ImportantNoticeDetail from "../pages/clubApp/content/ImportantNoticeDetail";
import WaitingForReview from "../pages/clubApp/graduation/WaitingForReview";
import GraduationReviewed from "../pages/clubApp/graduation/GraduationReviewed";
import PushNotification from "../pages/trialMode/pushNotification/PushNotification";
import ReviewGraduationCap from "../pages/clubApp/graduation/ReviewGraduationCap";
import ServiceBannerAndIcon from "../pages/clubApp/design/ServiceBannerAndIcon";
import AnnouncementBar from "../pages/clubApp/design/AnnouncementBar";
import AdExclusionList from "../pages/mkt/content/AdExclusionList";
import ReleaseVersion from "../pages/clubApp/version/ReleaseVersion";
import SalesPushNotification from "../pages/sales188/pushNotification/PushNotification";
import ViewNotificationDetail from "../pages/sales188/pushNotification/ViewNotificationDetail";
import CreateNotification from "../pages/sales188/pushNotification/CreateNotification";
import LeadsDetailDownload from "../pages/trialMode/dataAnalysis/leadsDetailDownload";
import CampaignId from "../pages/trialMode/dataAnalysis/campaignId";
import Sales188ReleaseVersion from "../pages/sales188/version/ReleaseVersion";
import KidsInfo from "../pages/clubApp/graduation/KidsInfo";
import DemoAppDashboard from "../pages/demoApp/dashboard/";
import ServiceTemplate from "../pages/demoApp/VideoManagement/ServiceTemplate";
import LeadList from "../pages/sales188/leadsManagement/leadList";
import LeadDetail from "../pages/sales188/leadsManagement/leadDetail";
import BuyUpQuery from "../pages/clubApp/buyUpQuery/BuyUpQuery";
import GetWinner from "../pages/mkt/content/GetWinner";
import MergeLeads from "../pages/mkt/content/MergeLeads";
import UpdateSourceCode from "../pages/mkt/content/UpdateSourceCode";
import SalesCalendar from "../pages/sales188/businessManagement/Calendar";
import AdvisorRegion from "../pages/sales188/systemManagement/AdvisorRegion";
import LeadRegistration from "../pages/sales188/leadsManagement/leadRegistraion";
import MediaCode from "../pages/sales188/systemManagement/MediaCode";
import AdvisorManagement from "../pages/sales188/systemManagement/AdvisorManagement";
import AdvisorDetail from "../pages/sales188/systemManagement/AdvisorDetail";
import MemberInfo from "../pages/sales188/memberInfo/MemberInfo";
import Announcement from "../pages/sales188/businessManagement/Announcement";
import AnnouncementList from "../pages/sales188/businessManagement/AnnouncementList";
import PowerBiTest from "../pages/clubApp/powerBiTest/PowerBiTest";
import TrialModeServiceTemplate from "../pages/trialMode/VideoManagement/ServiceTemplate";
import OneOnOneBoard from "../pages/sales188/businessManagement/OneOnOneBoard";
import OneOnOneDetail from "../pages/sales188/businessManagement/OneOnOneDetail";
import MessageBox from "../pages/sales188/businessManagement/MessageBox";
import CreateMessage from "../pages/sales188/businessManagement/CreateMessage";
import MessageDetail from "../pages/sales188/businessManagement/MessageDetail";
import EALMBonus from "../pages/mkt/content/EALMBonus";
import EALMBonusIncentive from "../pages/mkt/content/EALMBonusIncentive";
import EALMVendorPerformance from "../pages/mkt/content/EALMVendorPerformance";
import DlUpload from "../pages/sales188/leadsManagement/DlUpload";
import GoGoLiveDetail from "../pages/clubApp/design/components/GoGoLiveDetail";
import InternetSourceCost from "../pages/mkt/content/InternetSourceCost";
import SalesContestReport from "../pages/sales188/taiwanSalesManagement/SalesContestReport";
import InternetLeadsConversion from "../pages/mkt/LeadsManagement/InternetLeadsConversion";
import StoryTime from "../pages/zippyAndMe/storyTime/storyTime";
import StoryTimeDetail from "../pages/zippyAndMe/storyTime/storyTimeDetail";
import KidsWorld from "../pages/clubApp/videos/KidsWorld";
import Warranty from "../pages/clubApp/warranty/Warranty";
import WarrantyInfo from "../pages/clubApp/warranty/WarrantyInfo";
import DailyCheckIn from "../pages/zippyAndMe/dailyCheckIn/dailyCheckIn";
import ContentTabContentDetail from "../pages/zippyAndMe/dailyCheckIn/contentTabContentDetail";
import Channel from "../pages/zippyAndMe/channel/channel";
import ZippyFaceCall from "../pages/zippyAndMe/faceCall/faceCall";
import TrialModeAnnouncementBar from "../pages/trialMode/announcementBar/AnnouncementBar";
import EntryPackageQuery from "../pages/clubApp/entryPackageQuery/EntryPackageQuery";

interface AllRoutesProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const AllRoutes = ({
  setSelectedService,
  setSelectSubItem,
}: AllRoutesProps) => {
  return (
    <Routes>
      <Route path="/" element={<ClubAppDashboard />} />
      <Route path="/club-app/dashboard" element={<ClubAppDashboard />} />
      <Route
        path="/club-app/service-banner-and-icon"
        element={
          <ServiceBannerAndIcon
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/announcement-bar"
        element={
          <AnnouncementBar
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/event-banner"
        element={
          <EventBanner
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/ves"
        element={
          <GoGoLive
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/ves/:type/create"
        element={
          <GoGoLiveDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/ves/:id/detail"
        element={
          <GoGoLiveDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/push-notification"
        element={
          <Notification
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/push-notification/create"
        element={
          <ManualNotificationDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/push-notification/:id/detail"
        element={
          <ManualNotificationDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/face-call"
        element={
          <FaceCall
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/club-app/kids-world" element={<KidsWorld />} />
      <Route
        path="/club-app/warranty"
        element={
          <Warranty
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/warranty/:applicationId/detail"
        element={
          <WarrantyInfo
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/important-notice"
        element={
          <ImportantNotice
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/important-notice-detail/:market"
        element={<ImportantNoticeDetail />}
      />
      <Route
        path="/club-app/waiting-for-review"
        element={
          <WaitingForReview
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/review-graduation-cap/:id"
        element={<ReviewGraduationCap />}
      />
      <Route
        path="/club-app/all-applications"
        element={
          <GraduationReviewed
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/kids-info"
        element={
          <KidsInfo
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/release-version"
        element={
          <ReleaseVersion
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/buy-up-query"
        element={
          <BuyUpQuery
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/power-bi-test"
        element={
          <PowerBiTest
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/club-app/entry-package-query"
        element={
          <EntryPackageQuery
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/check-in-app/dashboard" element={<CheckInDashboard />} />
      <Route
        path="/club-service/dashboard"
        element={<ClubServiceDashboard />}
      />
      <Route path="/sales188/dashboard" element={<Sales188Dashboard />} />
      <Route
        path="/sales188/release-version"
        element={
          <Sales188ReleaseVersion
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/push-notification"
        element={
          <SalesPushNotification
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/push-notification/:id"
        element={
          <ViewNotificationDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/create-notification"
        element={
          <CreateNotification
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/member-info"
        element={
          <MemberInfo
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/sales-contest-report"
        element={
          <SalesContestReport
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/lead-inquiry"
        element={
          <LeadList
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/calendar"
        element={
          <SalesCalendar
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/announcement/:id/:type?"
        element={
          <Announcement
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/announcement-list"
        element={
          <AnnouncementList
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/announcement-list"
        element={
          <AnnouncementList
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/one-on-one-board"
        element={
          <OneOnOneBoard
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/one-on-one-detail/:id"
        element={
          <OneOnOneDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/message-box"
        element={
          <MessageBox
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/create-message"
        element={
          <CreateMessage
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/message-detail/:id"
        element={
          <MessageDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/lead-registration"
        element={
          <LeadRegistration
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/dl-upload"
        element={
          <DlUpload
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/advisor-region"
        element={
          <AdvisorRegion
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/advisor-management"
        element={
          <AdvisorManagement
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/advisor-management/:companyNumber"
        element={
          <AdvisorDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/media-code"
        element={
          <MediaCode
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/sales188/lead-detail/:leadNo"
        element={
          <LeadDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/mkt/dashboard" element={<MktDashboard />} />
      <Route
        path="/mkt/vendor-reports"
        element={
          <VendorReports
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/get-winner"
        element={
          <GetWinner
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/merge-leads"
        element={
          <MergeLeads
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/update-source-code"
        element={
          <UpdateSourceCode
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/ad-exclusion-list"
        element={
          <AdExclusionList
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/ealm-bonus"
        element={
          <EALMBonus
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/ealm-bonus-incentive"
        element={
          <EALMBonusIncentive
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/ealm-vendor-performance"
        element={
          <EALMVendorPerformance
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/internet-source-cost"
        element={
          <InternetSourceCost
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/mkt/internet-leads-Conversion"
        element={
          <InternetLeadsConversion
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/techpresso/dashboard" element={<TechpressoDashboard />} />
      <Route path="/demo-app/dashboard" element={<DemoAppDashboard />} />
      <Route
        path="/demo-app/club-services"
        element={
          <ServiceTemplate
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
            category="club-services"
          />
        }
      />
      <Route
        path="/demo-app/testimonial"
        element={
          <ServiceTemplate
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
            category="testimonial"
          />
        }
      />
      <Route
        path="/demo-app/company-news"
        element={
          <ServiceTemplate
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
            category="news"
          />
        }
      />
      <Route path="/trial-mode/dashboard" element={<TrialModeDashboard />} />
      <Route
        path="/trial-mode/leads-detail-download"
        element={
          <LeadsDetailDownload
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/campaign-id"
        element={
          <CampaignId
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/local-event"
        element={
          <LocalEvent
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/caring-cta"
        element={
          <CaringCTA
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/journey-card"
        element={
          <JourneyCard
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/trial-content"
        element={
          <TrialContent
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/trial-content-upload"
        element={
          <TrialContentUpload
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/trial-testimonial"
        element={
          <TrialModeServiceTemplate
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
            category="trial-testimonial"
          />
        }
      />
      <Route
        path="/trial-mode/push-notification"
        element={
          <PushNotification
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/trial-mode/trial-announcement-bar"
        element={
          <TrialModeAnnouncementBar
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/zippy-and-me/dashboard" element={<ZippyAndMeDashboard />} />
      <Route
        path="/zippy-and-me/story-time"
        element={
          <StoryTime
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/zippy-and-me/story-time/:id/detail"
        element={
          <StoryTimeDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/zippy-and-me/daily-check-in"
        element={
          <DailyCheckIn
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/zippy-and-me/daily-check-in/content/:id/detail"
        element={
          <ContentTabContentDetail
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/zippy-and-me/channel"
        element={
          <Channel
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route
        path="/zippy-and-me/face-call"
        element={
          <ZippyFaceCall
            setSelectedService={setSelectedService}
            setSelectSubItem={setSelectSubItem}
          />
        }
      />
      <Route path="/permission/user-management" element={<UserManagement />} />
      <Route path="/permission/program-setting" element={<ProgramSetting />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AllRoutes;
